import React, {useState} from "react";
import {useSelector} from "react-redux";
import axios from "axios"
import UserDropdown from "components/Dropdowns/UserDropdown.js";
import { Action, Store } from "@byhuz/huz-ui-state";
import { Redirect } from "react-router-dom";

export default function Navbar() {
  const [redirectChangePassword, setRedirectChangePassword] = useState(false); 
  const user=useSelector(state=>state.default?.user||{});
  //console.log(user);  

  const onLogout = (e) => {
        axios.get('logoff')
        .then(res=>{
          Store.dispatch(Action.update("loggedIn", false));
        })
        .catch(err=>{
          console.log(err);
        })
  }

  const onChangePassword = (e) => {
      setRedirectChangePassword(true);
  }

  if (redirectChangePassword){
    console.log("Redirect to Change Password");
    return <Redirect to={{
      pathname: '/auth/changepassword'
    }} />;
  }

  return (
    <>
      {/* Navbar */}
      <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-no-wrap md:justify-start flex items-center">
        <div className="w-full mx-autp items-center flex justify-between md:flex-no-wrap flex-wrap md:px-10 px-4">
          {/* Brand */}
          <a
            className="text-white text-sm uppercase hidden lg:inline-block font-semibold"
            href="#home"
            onClick={(e) => e.preventDefault() }
          >
            Dashboard
          </a>
          {/* User */}
          <ul className="flex-col md:flex-row list-none items-center hidden md:flex ml-auto">
            <UserDropdown onLogout={onLogout} onChangePassword={onChangePassword} user={user}/>
          </ul>
        </div>
      </nav>
      {/* End Navbar */}
    </>
  );
}
